<template>
  <svg
    width="37"
    height="44"
    viewBox="0 0 37 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.25 25.7076C0.25 35.7076 8.375 43.8326 18.375 43.8326C28.375 43.8326 36.5 35.7076 36.5 25.7076C36.5 21.5409 35.0417 17.5826 32.4375 14.3534C31.7083 13.5201 30.4583 13.5201 29.625 14.2493L22.125 21.0201C21.9167 21.2284 21.6042 20.9159 21.7083 20.7076C24.625 14.5618 24 7.06177 19.625 1.54094C18.8958 0.603439 17.5417 0.603439 16.7083 1.43677L5.5625 12.8951C2.125 16.3326 0.25 20.9159 0.25 25.7076Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ProductMenuIcon5',
} as DefineComponent
</script>
